import listStyles from '../../style/styles/Display.module.css';
import styles from '../../style/styles/ProductView.module.css';
import { redirectToPage, sendAddProductToCart } from '../../utils/utils';
import { useUserStore, useChatStateStore, useToastStore, useChatbotStore } from '../../zustand/store';
import { useUserEventLegacy } from '../../services/queries/chatbotQueries';
import { contents } from '../../data/contents';
import { useNavigate } from 'react-router-dom';


export const ProductShrinkView = (props) => {
    const { singleProductList } = props;
    const { partnerType, isMobileDevice, chatUserId } = useUserStore();
    const { chatbot } = useChatbotStore();
    const { mutate: postUserEventLegacy } = useUserEventLegacy();
    const { isConsole, isNewProduct, language, addToCartWithOption } = useChatStateStore();
    const { setToastMessage, setIsToastVisible } = useToastStore();
    const showCartCta = partnerType === 'cafe24'
    const navigate = useNavigate();

    return (
        singleProductList.map((product, idx) => {
            if (partnerType === 'fastfive') {
                return (
                    <div
                        key={idx}
                        className={`${styles.ProductShrinkView__productCardWrap} carousel-card ${isNewProduct && listStyles.bounce}`}
                        style={{ cursor: product?.productUrl && product?.productUrl.length > 0 ? 'pointer' : 'default' }}
                        onClick={() => {
                            redirectToPage(
                                product?.productUrl,
                                isConsole,
                                isMobileDevice
                            );
                            postUserEventLegacy({
                                eventCategory: 'CarouselClicked',
                                product: product,
                            });
                        }}
                    >
                        {
                            !isMobileDevice ?
                                <div className='spacing-56' /> :
                                <div className='spacing-16' />
                        }
                        <img src={product.imageUrl} alt={product.name} width={34} height={34} />
                        <div className='spacing-12' />
                        <div>
                            <p className='h8 fc-gray-800'>{product.name}</p>
                            <div className='spacing-4' />
                            <p className='h9 fc-gray-500' style={{ overflow: 'hidden', display: '-webkit-box', WebkitLineClamp: 1, WebkitBoxOrient: 'vertical' }}>{product.shortDesc}</p>
                        </div>
                        {
                            !isMobileDevice ?
                                <div className='spacing-56' /> :
                                <div className='spacing-16' />
                        }
                    </div>
                )
            } else {
                return (
                    <div
                        key={idx}
                        className={`${styles.ProductShrinkView__productCardWrap} carousel-card ${isNewProduct && listStyles.bounce}`}
                        style={{ cursor: product?.productUrl && product?.productUrl.length > 0 ? 'pointer' : 'default' }}
                        onClick={() => {
                            redirectToPage(
                                product?.productUrl,
                                isConsole,
                                isMobileDevice
                            );
                            postUserEventLegacy({
                                eventCategory: 'CarouselClicked',
                                product: product,
                            });
                        }}
                    >
                        {
                            !isMobileDevice ?
                                <div className='spacing-56' /> :
                                <div className='spacing-16' />
                        }
                        <div className={styles.ProductShrinkView__productCardInnerWrap}>
                            <div className={styles.ProductShrinkView__productCardInfo}>
                                <img src={product.imageUrl} alt={product.name} className={styles.ProductShrinkView__image} />
                                <div className='spacing-12' />
                                <div>
                                    <div style={{ display: 'flex' }}>
                                        <p
                                            className='h9 fc-gray-800'
                                            style={{
                                                height: '16px',
                                                overflow: 'hidden',
                                                display: '-webkit-box',
                                                WebkitLineClamp: 1,
                                                WebkitBoxOrient: 'vertical',
                                            }}
                                        >{product.name}</p>
                                    </div>
                                    <div className='spacing-4' />
                                    <div style={{ display: 'flex' }}>
                                        {
                                            chatbot?.isCarouselPriceVisible ?
                                                <>
                                                    {
                                                        product.discount > 0 &&
                                                        <>
                                                            <p className='h8 fc-warning'>{product.discount}%</p>
                                                            <div className='spacing-4' />
                                                        </>
                                                    }
                                                    <p className='h8 fc-gray-800'>{contents.carousel[language].priceUnit}{product?.price?.toLocaleString()}</p>
                                                    <div className='spacing-8' />
                                                </> :
                                                null
                                        }
                                        {
                                            product?.rate > 0 ?
                                                <>
                                                    <img src='/img/units/star-gray-300.png' width={14} height={14} alt='star' />
                                                    <div className='spacing-2' />
                                                    <p className='h9 fc-gray-500'>{product.rate.toFixed(1)}</p>
                                                    <div className='spacing-8' />
                                                    <p className='h9 fc-gray-500'>{contents.carousel[language].review}{' '}{product.reviewNum}</p>
                                                    <div className='spacing-8' />
                                                </> :
                                                <>
                                                    <p className='h9 fc-gray-500'>{contents.carousel[language].new}</p>
                                                    <div className='spacing-8' />
                                                </>
                                        }
                                    </div>
                                </div>
                            </div>
                            {
                                showCartCta &&
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <div className='spacing-20' />
                                    <div
                                        className={styles.CartButton__sizeM}
                                        onClick={(e) => {
                                            if (addToCartWithOption) {  // FlowLift C
                                                if (product?.hasOption === 'T') {
                                                    e.stopPropagation();
                                                    sessionStorage.setItem('product-option', JSON.stringify(product));
                                                    navigate(`/chat/${chatbot.chatbotId}/${chatUserId}/${product.itemId}`);
                                                } else if (product?.hasOption === 'F') {  
                                                    e.stopPropagation();
                                                    sendAddProductToCart(product, isConsole, isMobileDevice, setToastMessage, setIsToastVisible);
                                                    postUserEventLegacy({
                                                        eventCategory: 'AddToCartCarousel',
                                                        product: product,
                                                    });
                                                } else { // fall back
                                                    console.warn('variantList of product is empty');
                                                    setToastMessage('이 상품은 직접 담아주세요');	// 추후 수정 필요
                                                    setIsToastVisible(true);
                                                    return;
                                                } 
                                            } else {                    // FlowLift B
                                                e.stopPropagation();
                                                sendAddProductToCart(product, isConsole, isMobileDevice, setToastMessage, setIsToastVisible);
                                                postUserEventLegacy({
                                                    eventCategory: 'AddToCartCarousel',
                                                    product: product,
                                                });
                                            }
                                        }}
                                    >
                                        <img src='/img/units/carousel-cart.png' width={18} height={18} alt='cart' />
                                    </div>
                                </div>
                            }
                        </div>
                        {
                            !isMobileDevice ?
                                <div className='spacing-56' /> :
                                <div className='spacing-16' />
                        }
                    </div>
                )
            }
        })
    )
}